module.exports = __webpack_public_path__ + "static/5-b6ce2d493b3ba6fb3dffa756cef89b15.png";